import { ChangeEvent, KeyboardEvent } from 'react';
import { IoMdSearch } from 'react-icons/io';
import { CSS, Flex, Label, TextField, theme } from '@ghq-abi/design-system';

type FilterTextFieldProps = {
  id: string;
  value: string;
  placeholder: string;
  label?: string;
  isLoading: boolean;
  disabled: boolean;
  css?: CSS;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onConfirm: () => void;
};

export function FilterTextField({
  id,
  label,
  value,
  placeholder,
  isLoading,
  disabled,
  onChange,
  onConfirm,
  css,
}: FilterTextFieldProps) {
  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  return (
    <Flex direction="column" gap="md" css={css}>
      {label && (
        <Label
          htmlFor={id}
          css={{
            fontWeight: '$medium',
            color: '$gray750',
            fontSize: '$sm',
          }}
        >
          {label}
        </Label>
      )}
      <TextField
        id={id}
        disabled={isLoading || disabled}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        onKeyDown={e => handleKeyPress(e)}
        rightIcon={
          <IoMdSearch
            onClick={onConfirm}
            style={{
              width: theme.sizes[6].value,
              height: theme.sizes[6].value,
            }}
          />
        }
        css={{ fontSize: '$sm', minWidth: '238px' }}
        containerCss={{ flex: 1 }}
      />
    </Flex>
  );
}
